import { CalendarDate, Charge, ChargeStatus, UpdateChargeInput, fromCalendarDate } from '@rentguru/commons-utils';

export interface ChargeAffectationPeriod {
  periodFrom: string;
  periodTo: string;
}

export const buildChargeAffectationUpdate = (
  charge: Charge,
  { periodFrom, periodTo }: ChargeAffectationPeriod,
  affectedOn: CalendarDate
): UpdateChargeInput | null => {
  if (charge.status !== ChargeStatus.TO_AFFECT) {
    return null;
  }
  return {
    id: charge.id,
    status: ChargeStatus.AFFECTED,
    archivedDate: fromCalendarDate(affectedOn),
    periodFrom,
    periodTo,
    _version: charge._version,
  };
};
